// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2CmUY","sectionContainer":"styles_sectionContainer__2fnVg","sectionContent":"styles_sectionContent__3nlA1","sectionBody":"styles_sectionBody__LApAC"};